module.exports = __webpack_public_path__ + "static/media/background-detail.6f52fcd8.png";